<template>
  <v-row justify="center">
    <v-dialog
      v-model="getPreordiniDelete"
      persistent
      max-width="350"
    >
      <v-card>
        <v-card-title class="headline">Cancellare preordine?</v-card-title>

        <v-card-text>
          Confermando, il preordine verrà eliminato dal database.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            text
            @click="remove"
          >
            Conferma
          </v-btn>

          <v-btn
            color="primary"
            @click="dismiss"
          >
            Annulla
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import axios from 'axios'
  import { mapGetters, mapMutations } from 'vuex'

  export default {
    name: 'DeleteDialog',

    data() {
      return {
        config: {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        },
      }
    },

    computed: {
      ...mapGetters([
        'getPreordiniDelete',
        'getPreordiniSelected',
      ]),
    },

    methods: {
      dismiss() {
        this.$emit('dismiss')
      },

      async remove() {
        const { data } = await axios.post(
          `${process.env.VUE_APP_API}/preorders/delete`,
          { id: this.getPreordiniSelected.id },
          this.config
        )

        if (data.status) {
          this.$emit('saved')
        }
      }
    }
  }
</script>

<style>
</style>